
// import * as productUnitType from '~/constants/productUnitType'
import { commonfunc } from '~/mixin/common'
import * as productUnitType from '~/constants/productUnitType'
import { normalizeResponse } from '~/scriptData/common/models/productModel'
import { PRODUCT_LIST_TYPES } from '~/scriptData/common/product/defineListType'

import DaisoImage from '~/components/common/DaisoImage.vue'
import ChatbotButton from '~/components/common/button/chatbot/ChatbotButton.vue'
import ProductListWrapper from '~/components/organism/common/product/ProductListWrapper.vue'
import NoData from '~/components/common/template/NoData.vue'

export default {
  components: {
    NoData,
    ProductListWrapper,
    DaisoImage,
    ChatbotButton
  },
  mixins: [commonfunc],
  props: {
    quickOn: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      todayProduct: [],
      PRODUCT_LIST_TYPES,
      isBtnActive: false,
      isQuickList: false,
      showRecentList: false,
      showRecentPanel: false,
      showButtons: true,
      srcAfter: 'cHJvakNkPURBSSZjaGFubmVsSWQ9MzI4',
      isChatbotIconShow: false,
      intervalChatbotIconShow: '',
      timeOutChatbotIconHidden: '',
      mbEid2: this.$store.getters['session/getMb'].mbEid2, // 고객 아이디를 화면에 담을 것.
      chatbotUrl: process.env.CHATBOT_URL,
      quickList: [
        {
          title: '공지사항',
          path: '/cs/csm/SCR_CSM_0000',
          icon: 'my_notice'
        },
        {
          title: 'FAQ',
          path: '/cs/csi/SCR_CSI_0001',
          icon: 'customcenter'
        },
        {
          title: '1:1 문의내역',
          path: '/cs/csk/SCR_CSK_0000',
          icon: 'questionlist'
        },
        {
          title: '1:1 문의',
          path: '/cs/csl/SCR_CSL_0001',
          icon: '1_1'
        }
      ],
    }
  },
  computed: {
    isChatbotEnabled () {
      return process.env.CHATBOT_ENABLED !== 'false'
    }
  },
  watch: {
    $route: {
      deep: true,
      handler () {
        this.getRecentlyProducts(JSON.parse(localStorage.getItem('visitedPdNo')))
        this.showRecentList = false
        this.showRecentPanel = false
        this.isQuickList = false
        this.isBtnActive = false
      }
    }
  },
  created () {
    console.group('created' + '>>' + (new Date()).toLocaleString() + '.' + (new Date()).getMilliseconds())
    this.mbEid2 = this.$store.getters['session/getMb'].mbEid2 // 고객 아이디를 화면에 담을 것.
    console.log('mbEid2:', this.$store.getters['session/getMb'].mbEid2)
    console.groupEnd()
  },
  mounted () {
    console.group('mounted' + '>>' + (new Date()).toLocaleString() + '.' + (new Date()).getMilliseconds())
    this.getRecentlyProducts(JSON.parse(localStorage.getItem('visitedPdNo')))
    // this.activateChatbotIcon() jsTag.setAttribute('onload', this.activateChatbotIcon()) 에서 호출함.

    // this.mbEid2 = this.$store.getters['session/getmbEid2'] // 고객 아이디를 화면에 담을 것.
    this.mbEid2 = this.$store.getters['session/getMb'].mbEid2
    console.log('mbEid2:', this.$store.getters['session/getMb'].mbEid2)
    console.groupEnd()
    window.addEventListener('visitedPdNoChanged', this.handleVisitedPdNoChanged)
  },
  beforeDestroy () {
    window.removeEventListener('visitedPdNoChanged', this.handleVisitedPdNoChanged)
  },
  methods: {
    handleVisitedPdNoChanged (e) {
      this.getRecentlyProducts(e.detail)
    },
    goScrollTop (e) {
      this.$emit('scrollTop')
    },
    async getRecentlyProducts (cookiePdNo) {
      // this.todayProduct = []
      const payload = []
      if (this.isNotEmpty(cookiePdNo)) {
        cookiePdNo.forEach((item) => {
          payload.push(item.pdNo)
        })
      }

      if (payload.length > 0) {
        const resData = await this.$AxiosBuilder
          .data({ pdNoArr: payload })
          .build()
          .post('/pdo/pdThumbCompact')
          .then((res) => {
            return res.data.data
          })

        if (resData !== null && resData !== undefined && resData.length > 0) {
          this.todayProduct = []
          payload.forEach((reqItem) => {
            resData.forEach((resItem, resIndex) => {
              if (reqItem === resItem.pdNo) {
                const normalizedProduct = normalizeResponse(resItem, productUnitType.PD_PRODUCT)
                this.todayProduct.push(normalizedProduct)
              }
            })
          })
          console.log('최근본')
          console.log(this.todayProduct)
        }
      }
    },
    resetRecentlyProducts () {
      this.$confirm('최근 본 상품을 전체삭제 하시겠습니까?', '삭제하기', {
        confirmButtonText: '확인',
        cancelButtonText: '취소'
      }).then(() => {
        this.todayProduct = []
        localStorage.setItem('visitedPdNo', null)
      })
    },
    deleteSingleProduct (pdNo) {
      // this.$confirm('이 상품을 삭제하시겠습니까?', '삭제하기', {
      //   confirmButtonText: '확인',
      //   cancelButtonText: '취소'
      // }).then(() => {
      // todayProduct 배열에서 해당 상품 제거
      this.todayProduct = this.todayProduct.filter(product => product.pdNo !== pdNo)

      // localStorage에서도 해당 상품 제거
      const visitedPdNo = JSON.parse(localStorage.getItem('visitedPdNo'))
      if (visitedPdNo && Array.isArray(visitedPdNo)) {
        const updatedVisitedPdNo = visitedPdNo.filter(item => item.pdNo !== pdNo)
        localStorage.setItem('visitedPdNo', JSON.stringify(updatedVisitedPdNo))
      }
    },
    handleDeleteProduct (item) {
      if (item && item.pdNo) {
        this.deleteSingleProduct(item.pdNo)
      }
    },
    toggleQuickCenter () {
      this.isBtnActive = !this.isBtnActive
      this.isQuickList = !this.isQuickList
      this.showRecentList = false
    },
    toggleRecentList () {
      this.showRecentList = !this.showRecentList
      this.showRecentPanel = this.showRecentList
      if (this.showRecentPanel) {
        this.showButtons = false
      }
      this.isBtnActive = false
      this.isQuickList = false
    },
    hideQuick () {
      this.isBtnActive = false
      this.isQuickList = false
    },
    goMembership () {
      const mbMngNo = this.$store.getters['session/getMbMngNo']
      if (!mbMngNo) {
        this.$router.push('/mb/mbb/SCR_MBB_0097A')
      } else {
        this.$router.push({ path: '/ms/msb/SCR_MSB_0001' })
      }
    },
  }
}
